var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-jobs"},[_c('div',{staticClass:"margin-top-30"}),_vm._v(" "),_c('jobs-list')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }